module.exports = __webpack_public_path__ + "img/img_main_con2__.c22a29fa.png";